import { ChangeDetectionStrategy, Component, computed, forwardRef } from '@angular/core';
import { NodeViewComponent } from '@examdojo/core/tiptap';
import { SimpleSolverComponent } from '@examdojo/solver';
import { v4 as uuid } from 'uuid';
import { ContentBlockType, SimpleLayoutConfig, SimpleSolverBlock, SolverSlide } from '../../../model';
import { DragWithHandleOnlyDirective } from '../drag-with-handle-only.directive';
import { DEFAULT_SIMPLE_SOLVER_PROPS } from './simple-solver.model';

@Component({
  selector: 'dojo-simple-solver-node',
  standalone: true,
  imports: [SimpleSolverComponent],
  templateUrl: './simple-solver.component.html',
  styleUrls: ['./simple-solver.component.scss'],
  hostDirectives: [DragWithHandleOnlyDirective],
  providers: [
    {
      provide: NodeViewComponent,
      useExisting: forwardRef(() => SimpleSolverNodeComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleSolverNodeComponent extends NodeViewComponent<SimpleSolverBlock> {
  readonly name = this.getProp('name');
  readonly initialSuperLatexContent = this.getProp('initial_super_latex_content');
  readonly steps = this.getProp('steps');
  readonly width = this.getProp('width');
  readonly latexOnRight = this.getProp('latex_on_right');

  readonly slide = computed<SolverSlide>(() => ({
    name: this.name() ?? undefined,
    initial_super_latex_content: this.initialSuperLatexContent(),
    steps: this.steps(),
  }));

  readonly config = computed<SimpleLayoutConfig>(() => ({
    width: this.width() ?? 350,
    latex_on_right: this.latexOnRight() ?? false,
  }));

  override getDefaults = (): SimpleSolverBlock => ({
    ...DEFAULT_SIMPLE_SOLVER_PROPS,
    id: uuid(),
    type: ContentBlockType.SimpleSolver,
  });

  onWidthChange(width: number): void {
    this.updateProp('width', width);
  }
}
